// Generated by BUCKLESCRIPT VERSION 4.0.18, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

function str(prim) {
  return prim;
}

function onChangeEvent(fn, evt) {
  var text = evt.target.value;
  if (fn !== undefined) {
    Curry._1(fn, text);
  }
  return /* () */0;
}

var component = ReasonReact.statelessComponent("Spinner");

function make($staropt$star, param) {
  var label = $staropt$star !== undefined ? $staropt$star : "";
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function (param) {
              return React.createElement("div", {
                          className: "una-spinner"
                        }, React.createElement("i", {
                              className: "fa fa-circle-o-notch fa-spin"
                            }), React.createElement("span", undefined, label));
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* jsElementWrapped */component[/* jsElementWrapped */13]
        ];
}

exports.str = str;
exports.onChangeEvent = onChangeEvent;
exports.component = component;
exports.make = make;
/* component Not a pure module */
